import axios from 'axios';

const state = {};

const getters = {};

const actions = {};

const mutations = {};

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: null,
        permissions: null,
        formErrors: null,
    },

    getters: {
        authenticated (state) {
            return state.authenticated
        },

        user (state) {
            return state.user
        },

        permissions (state) {
            return state.permissions
        },

        formErrors (state) {
            return state.formErrors
        },
    },

    mutations: {
        SET_AUTHENTICATED (state, value) {
            state.authenticated = value
        },

        SET_USER (state, value) {
            state.user = value
        },

        SET_PERMISSIONS (state, value) {
            state.permissions = value
        },

        SET_FORM_ERRORS (state, value) {
            state.formErrors = value
        }
    },

    actions: {
        async signIn ({ dispatch, commit }, credentials) {
            await axios.get('/sanctum/csrf-cookie')
            await axios.post('/api/login', credentials)
                .then(response => {
                    commit('SET_FORM_ERRORS', null);
                }).catch(error => {
                    if (error.response.status === 422) { // Validation Error
                        commit('SET_FORM_ERRORS', error.response.data.errors);
                    }
                });

            return dispatch('me')
        },

        async signOut ({ dispatch }) {
            await axios.post('/api/logout')

            return dispatch('me')
        },

        me ({ commit }) {
            return axios.get('/api/user').then((response) => {
                commit('SET_AUTHENTICATED', true)
                commit('SET_USER', response.data.data)
                commit('SET_PERMISSIONS', response.data.data.user_permissions)
            }).catch(() => {
                commit('SET_AUTHENTICATED', false)
                commit('SET_PERMISSIONS', [])
                commit('SET_USER', null)
            })
        }
    }
}
